import { MyEquipmentButton } from '../my-equipment-button';
import { MyEquipmentSaveFooterProps } from '../types';
import { FC, PropsWithChildren } from 'react';

export const MyEquipmentSaveFooter: FC<
  PropsWithChildren<MyEquipmentSaveFooterProps>
> = ({
  disableSave,
  saveLabel,
  cancelLabel,
  cancelClass,
  onCancelHandler,
  disableCancel
}) => {
  return (
    <footer slot="footer">
      <MyEquipmentButton
        variant="primary"
        type="submit"
        disabled={disableSave}
        aria-label={saveLabel}
      >
        {saveLabel}
      </MyEquipmentButton>
      <MyEquipmentButton
        onClick={onCancelHandler}
        className={cancelClass}
        aria-label={cancelLabel}
        disabled={disableCancel}
      >
        {cancelLabel}
      </MyEquipmentButton>
    </footer>
  );
};
